export default __webpack_public_path__ + "static/media/logo-horizontal-light.15c0bb52.png";